import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";

const isStatusOption = [
  { id: 1, label: "Active", value: true },
  { id: 0, label: "Inactive", value: false },
];

const VehicleIndemnityForm = () => {
  const {
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="vehicleNumber"
          type="text"
          label="Vehicle Number"
          labelClassName="form-label"
          placeholder="Vehicle Number"
          className={`form-control ${errors.vehicleNumber ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Vehicle Number is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="indemnityNumber"
          type="text"
          label="Indemnity Number"
          labelClassName="form-label"
          placeholder="Indemnity Number"
          className={`form-control ${errors.indemnityNumber ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Indemnity Number is required -2"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="indemnityDate"
          type="date"
          label="Indemnity Date"
          labelClassName="form-label"
          placeholder="Indemnity Date"
          className={`form-control ${errors.indemnityDate ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Indemnity Date is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="driverName"
          type="text"
          label="Driver Name"
          labelClassName="form-label"
          placeholder="Driver Name"
          className={`form-control ${errors.driverName ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Driver Name is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="driverNRICFin"
          type="text"
          label="Driver NRIC/FIN"
          labelClassName="form-label"
          placeholder="Driver NRIC/FIN"
          className={`form-control ${errors.driverNRICFin ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Driver NRIC/FIN is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="ltA_HDB"
          type="text"
          label="LTA / HDB"
          labelClassName="form-label"
          placeholder="LTA or HDB"
          className={`form-control ${errors.ltA_HDB ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="LTA / HDB is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="noticeNumber"
          type="text"
          label="Notice Number"
          labelClassName="form-label"
          placeholder="Notice Number"
          className={`form-control ${errors.noticeNumber ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Notice Number is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="vendor"
          type="text"
          label="Vendor"
          labelClassName="form-label"
          placeholder="Vendor"
          className={`form-control ${errors.vendor ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Vendor is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="invoiceNumber"
          type="text"
          label="Invoice Number"
          labelClassName="form-label"
          placeholder="Invoice Number"
          className={`form-control ${errors.invoiceNumber ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Invoice Number is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="amount"
          type="number"
          label="Amount"
          labelClassName="form-label"
          placeholder="Amount"
          className={`form-control ${errors.amount ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Amount is required"
        />
      </div>

      <div className="col-md-8 col-sg-12 mb-3">
        <Input
          name="incidentAddress"
          type="text"
          label="Incident Address"
          labelClassName="form-label"
          placeholder="Incident Address"
          className={`form-control ${errors.incidentAddress ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Incident Address is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="issuedBy"
          type="text"
          label="Issued By"
          labelClassName="form-label"
          placeholder="Issued By"
          className={`form-control ${errors.issuedBy ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Issued By is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="designation"
          type="text"
          label="Designation"
          labelClassName="form-label"
          placeholder="Designation"
          className={`form-control ${errors.designation ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Designation is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="issuerNRIC"
          type="text"
          label="Issuer NRIC"
          labelClassName="form-label"
          placeholder="Issuer NRIC"
          className={`form-control ${errors.issuerNRIC ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Issuer NRIC is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="debitStaffAmount"
          type="number"
          label="Debit Staff Amount"
          labelClassName="form-label"
          placeholder="Debit Staff Amount"
          className={`form-control ${errors.debitStaffAmount ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Debit Staff Amount is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="writeOffAmount"
          type="number"
          label="Write-off Amount"
          labelClassName="form-label"
          placeholder="Write-off Amount"
          className={`form-control ${errors.writeOffAmount ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Write-off Amount is required"
        />
      </div>

      <div className="col-md-8 col-sg-12 mb-3">
        <Input
          name="description"
          type="text"
          label="Description"
          labelClassName="form-label"
          placeholder="Penalty or Description"
          className={`form-control ${errors.description ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Description is required"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder="Select Status"
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          className={`form-control select ${errors.isActive ? "is-invalid" : ""}`}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption?.value);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
    </div>
  );
};

export default VehicleIndemnityForm;
